import styled, { css } from 'styled-components';
import { breakpoint, pxToRem } from '@fil-react-mixins/styled';
import Heading from './Heading';
export const HeadingXXL = styled(Heading).attrs((props) => ({
    as: props.as || 'h1',
})) `
  font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-xxl']['font-size'].value, 10))};
  line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-xxl']['line-height'].value, 10))};
  margin-bottom: 3rem;
  ${breakpoint('lg', css `
      font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-xxl']['font-size'].value, 10))};
      line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-xxl']['line-height'].value, 10))};
      margin-bottom: 4rem;
    `)}
`;
HeadingXXL.displayName = 'HeadingXXL';
export const HeadingXL = styled(Heading).attrs((props) => ({
    as: props.as || 'h1',
})) `
  font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-xl']['font-size'].value, 10))};
  line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-xl']['line-height'].value, 10))};
  margin-bottom: 3rem;
  ${breakpoint('lg', css `
      font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-xl']['font-size'].value, 10))};
      line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-xl']['line-height'].value, 10))};
      margin-bottom: 4rem;
    `)}
`;
HeadingXL.displayName = 'HeadingXL';
export const HeadingL = styled(Heading).attrs((props) => ({
    as: props.as || 'h2',
})) `
  font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-l']['font-size'].value, 10))};
  line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-l']['line-height'].value, 10))};
  margin-bottom: 2.5rem;
  ${breakpoint('lg', css `
      font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-l']['font-size'].value, 10))};
      line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-l']['line-height'].value, 10))};
      margin-bottom: 3.375rem;
    `)}
`;
HeadingL.displayName = 'HeadingL';
export const HeadingM = styled(Heading).attrs((props) => ({
    as: props.as || 'h3',
})) `
  font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-m']['font-size'].value, 10))};
  line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-m']['line-height'].value, 10))};
  margin-bottom: 2.0265rem;
  ${breakpoint('lg', css `
      font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-m']['font-size'].value, 10))};
      line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-m']['line-height'].value, 10))};
      margin-bottom: 2.3125rem;
    `)}
`;
HeadingM.displayName = 'HeadingM';
export const HeadingS = styled(Heading).attrs((props) => ({
    as: props.as || 'h4',
})) `
  font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-s']['font-size'].value, 10))};
  line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-s']['line-height'].value, 10))};
  margin-bottom: 1.75rem;
  ${breakpoint('lg', css `
      font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-s']['font-size'].value, 10))};
      line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-s']['line-height'].value, 10))};
      margin-bottom: 1.9375rem;
    `)}
`;
HeadingS.displayName = 'HeadingS';
export const HeadingXS = styled(Heading).attrs((props) => ({
    as: props.as || 'h5',
})) `
  font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-xs']['font-size'].value, 10))};
  line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-small']['heading-xs']['line-height'].value, 10))};
  margin-bottom: 1.4375rem;
  ${breakpoint('lg', css `
      font-size: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-xs']['font-size'].value, 10))};
      line-height: ${(props) => pxToRem(parseInt(props.theme.size.font['bp-large']['heading-xs']['line-height'].value, 10))};
      margin-bottom: 1.625rem;
    `)}
`;
HeadingXS.displayName = 'HeadingXS';
